import React, { useState, useEffect } from 'react';

import TextField from '@material-ui/core/TextField';
import Modal from 'components/Tvendo/Common/ModalBase';
import Autocomplete from '@material-ui/lab/Autocomplete';
import moment from 'moment';
import { WithApp } from 'contexts/appContext';
import { ImportExcel } from 'components/Tvendo/Common/ImportExcel';
import { wsGetAll, wsGet } from 'services/WService.js';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';

export default WithApp(function ModalCuotaProvider(props) {
    const cuota = props.model;
    const [imageUrl, setImageUrl] = useState('');
    const [dataDetails, setDataDetails] = useState(null);
  
    const generateImageUrl = (fileId) => {
      // return `https://drive.google.com/file/d/1eXpbq396keK6qQ9_SkADjsLh42eNng08/preview`;
      return `https://drive.google.com/file/d/${fileId}/preview`;
    };
    async function fetchDetails() {
        let response = await wsGet('sale/form-supervisores', cuota.idFotoEvidencia);
        if (response.success) {
            setDataDetails(response.data);
        }
    }
    useEffect(() => {
        fetchDetails()
    }, []);
  
    return (
      <Modal
        title={`Imagen para el vendedor: ${cuota.nombreVendedor}`}
        model={{ open: cuota.open }}
        setOpen={props.setOpen}
        showNotify={props.showNotify}
        reload={props.reload}
        arrDataResponse
        entity="sale/form-supervisores-detail"
      >
        {/* <iframe src={generateImageUrl()} alt="Evidencia" style={{ width: '100%', height: '600px' }} /> */}
        <iframe src={generateImageUrl(cuota.idFotoEvidencia)} alt="Evidencia" style={{ width: '100%', height: '600px' }} />
      </Modal>
    );
  });